export const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_BASE_URL;
  if (!envUrl || !envUrl.trim()) {
    throw new Error('Missing REACT_APP_API_BASE_URL in .env');
  }

  return envUrl.trim().replace(/\/+$/, '');
};

